import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "./auth-service-tools36.js";
import { shiftTimezone } from "./auth-service-tools574.js";
import { useDatesContext } from "./auth-service-tools577.js";

function formatValue(value, type) {
  const ctx = useDatesContext();

  const formatDateWithTimezone = date => {
    return shiftTimezone("remove", date, ctx.getTimezone()).toISOString();
  };

  if (type === "range" && Array.isArray(value)) {
    const [startDate, endDate] = value;

    if (!startDate) {
      return "";
    }

    if (!endDate) {
      return `${formatDateWithTimezone(startDate)} –`;
    }

    return `${formatDateWithTimezone(startDate)} – ${formatDateWithTimezone(endDate)}`;
  }

  if (type === "multiple" && Array.isArray(value)) {
    return value.map(date => date && formatDateWithTimezone(date)).filter(Boolean).join(", ");
  }

  if (!Array.isArray(value) && value) {
    return formatDateWithTimezone(value);
  }

  return "";
}

function HiddenDatesInput(_ref) {
  let {
    value,
    type,
    name,
    form
  } = _ref;
  return /* @__PURE__ */jsxRuntimeExports.jsx("input", {
    type: "hidden",
    value: formatValue(value, type),
    name,
    form
  });
}

HiddenDatesInput.displayName = "@mantine/dates/HiddenDatesInput";
export { HiddenDatesInput };